import { AuthApiError } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';

import { supabaseClient } from 'src/auth/supabase';

export const useUpdateUserPasswordSupabase = () =>
    useMutation<unknown, AuthApiError, { password: string }>({
        mutationKey: ['auth', 'password', 'update'],
        mutationFn: async ({ password }) => {
            const res = await supabaseClient.auth.updateUser({
                password,
            });

            if (res.error) throw res.error;

            return res.data;
        },
    });
